// Translations
import phoneVerificationDialog from '../components/phone-verification-dialog/translations/tr'

// Translation: Model > Phone number verifier (Turkish)
export default Object.freeze({
	actions: {
		verify: 'Doğrula'
	},
	components: { phoneVerificationDialog }
})
